import { render } from "./AppTopbar.vue?vue&type=template&id=000ff9e0"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"
script.render = render

export default script